// src/components/chat/VerticalDragDivider.jsx
import React, { useEffect, useRef, useCallback } from 'react';
import { useDmUiStore } from '../../state/dmUiStore';

const MIN_SIDEBAR_WIDTH = 220;
const MAX_SIDEBAR_WIDTH = 600;

export default function VerticalDragDivider() {
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);
  const setSidebarWidth = useDmUiStore((s) => s.setSidebarWidth);
  const sidebarWidth = useDmUiStore((s) => s.sidebarWidth);

  const onMouseMove = useCallback(
    (e) => {
      if (!isDraggingRef.current) return;
      const dx = e.clientX - startXRef.current;
      const newWidth = startWidthRef.current + dx;
      const clamped = Math.max(
        MIN_SIDEBAR_WIDTH,
        Math.min(MAX_SIDEBAR_WIDTH, newWidth)
      );
      setSidebarWidth(clamped);
    },
    [setSidebarWidth]
  );

  const onMouseUp = useCallback(() => {
    if (!isDraggingRef.current) return;
    isDraggingRef.current = false;
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  }, [onMouseMove]);

  const onMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      isDraggingRef.current = true;
      startXRef.current = e.clientX;
      startWidthRef.current = sidebarWidth;
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    },
    [sidebarWidth, onMouseMove, onMouseUp]
  );

  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, [onMouseMove, onMouseUp]);

  return (
    <div
      onMouseDown={onMouseDown}
      className="w-[6px] cursor-col-resize flex-shrink-0 flex items-stretch group"
    >
      <div className="w-[2px] mx-auto bg-gray-200 group-hover:bg-gray-400 transition-colors" />
    </div>
  );
}
